import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class UserCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    componentDidMount = () => {
		this._isMounted = true;

        API.Security.get('/query/getUsers', {},
        {
            success: (r) => {
                this._isMounted && this.setState({
                    items: r.data.items.map((item) => { return { label: item.fullName, value: item.userId } })
                });
            }
        }, { block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                searchable={true} />
        )
    }
}

export default UserCombo;

// Mark this as a form component
UserCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/userCombo/UserCombo.js